import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Nav from './Nav';
import Search from './Search';
import RandomRecord from './RandomRecord';

const App = () => {
  return (
    <Router>
      <Nav />
      <main style={{ paddingTop: '70px' }}>
        <Routes>
          <Route path="/" element={<RandomRecord />} />
          <Route path="/search" element={<Search />} />
        </Routes>
      </main>
    </Router>
  );
};

export default App;
